import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../services/Context";
import CryptoJS from "crypto-js";

/**
 * Componente que protege rutas requiriendo autenticación
 * Verifica el localStorage y restaura la sesión automáticamente
 */
const ProtectedRoute = ({ children }) => {
  const { userContext, setUserContext , restoreSession} = useContext(Context);
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tryRestoreSession = () => {
      try {
        const encryptedUser = localStorage.getItem("user");
        if (encryptedUser) {
          const bytes = CryptoJS.AES.decrypt(encryptedUser, `${process.env.TOKEN}`);
          const decryptedUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          if (decryptedUser) {
            restoreSession(decryptedUser);
          }
        }
      } catch (error) {
        console.error("Error al restaurar la sesión:", error);
        localStorage.removeItem("user");
      } finally {
        setLoading(false);
      }
    };

    if (!userContext) {
      tryRestoreSession();
    } else {
      setLoading(false);
    }
  }, [userContext, setUserContext]);

  // Mostrar loading mientras se verifica la sesión
  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5"
      }}>
        <div style={{ textAlign: "center" }}>
          <svg
            width="60"
            height="60"
            stroke="#DA2599"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g className="spinner_V8m1">
              <circle
                cx="12"
                cy="12"
                r="9.5"
                fill="none"
                strokeWidth="3"
              ></circle>
            </g>
          </svg>
          <p style={{ marginTop: "20px", color: "#666" }}>
            Verificando sesión...
          </p>
        </div>
      </div>
    );
  }

  // Si no hay usuario después de verificar, redirigir al login
  if (!userContext) {
    // Guardar la ruta a la que intentaba acceder para redirigir después del login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Usuario autenticado, renderizar el contenido protegido
  return children;
};

export default ProtectedRoute;
